import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL ;

// 👉 Create Holiday
export const addHoliday = createAsyncThunk("holiday/add", async (data, thunkAPI) => {
  try {
    const res = await axios.post(`${BASE_URL}/create-holiday`, data);
    if (res.data?.holidays?.length > 0) {
      return res.data.holidays[0];
    }
    return thunkAPI.rejectWithValue("Holiday creation failed");
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to add holiday");
  }
});

// 👉 Read Holidays
export const getHolidays = createAsyncThunk("holiday/getAll", async (_, thunkAPI) => {
  try {
          const superAdminId = localStorage.getItem("adminuserId"); // Read superAdminId

    const res = await axios.get(`${BASE_URL}/all-holiday?superAdminId=${superAdminId}`);
    return res.data.holidays || [];
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch holidays");
  }
});

// 👉 Update Holiday
export const updateHoliday = createAsyncThunk("holiday/update", async ({ id, data }, thunkAPI) => {
  try {
    const res = await axios.put(`${BASE_URL}/update-holiday/${id}`, data);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to update holiday");
  }
});

// 👉 Delete Holiday
export const deleteHoliday = createAsyncThunk("holiday/delete", async (id, thunkAPI) => {
  try {
    await axios.delete(`${BASE_URL}/delete-holiday/${id}`);
    return id;
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to delete holiday");
  }
});

const holidaySlice = createSlice({
  name: "holiday",
  initialState: {
    holidays: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearHolidayError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addHoliday.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.id) state.holidays.push(action.payload);
      })
      .addCase(getHolidays.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = action.payload;
      })
      .addCase(updateHoliday.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload;
        const index = state.holidays.findIndex(h => h.id === updated.id);
        if (index !== -1) state.holidays[index] = updated;
      })
      .addCase(deleteHoliday.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = state.holidays.filter(h => h.id !== action.payload);
      })

      // Common matchers
      .addMatcher(
        (action) => action.type.startsWith("holiday/") && action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("holiday/") && action.type.endsWith("/rejected"),
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      );
  },
});

export const { clearHolidayError } = holidaySlice.actions;
export default holidaySlice.reducer;
